import React from 'react';
import Header from '../../Components/Header/Header';
import NewCard from '../../Components/NewCard/NewCard';

const NewCardPage = () => {
  return (
    <div>
      <Header />
      <NewCard />
    </div>
  );
};

export default NewCardPage;
